export const isIOS = (): boolean => {
  // Check userAgent
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOSUserAgent = /iphone|ipad|ipod/.test(userAgent);

  // Check platform
  const platform = window.navigator.platform.toLowerCase();
  const isIOSPlatform = ["iphone", "ipad", "ipod"].includes(platform);

  // Check standalone mode (PWA) for iOS
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const standalone = (window.navigator as any).standalone;

  return isIOSUserAgent || isIOSPlatform || standalone;
};

export type BrowserType = "Chrome" | "Safari" | "Unknown";

export interface BrowserInfo {
  type: BrowserType;
  version: string;
  isChrome: boolean;
  isSafari: boolean;
  isUnknown: boolean;
  isMobilePlatform: boolean;
}

/**
 * Detects if the browser is Chrome or Safari
 * @returns Browser information including type and version
 */
export const getMobileBrowserInfo = (): BrowserInfo => {
  const userAgent = window.navigator.userAgent;
  let type: BrowserType = "Unknown";
  let version = "";
  const isMobilePlatform = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  // Check for Chrome on iOS (CriOS)
  if (/CriOS\//.test(userAgent)) {
    type = "Chrome";
    const match = userAgent.match(/CriOS\/(\d+(\.\d+)?)/);
    version = match ? match[1] : "";
  }
  // Safari (must be after Chrome checks)
  else if (/Safari\//.test(userAgent) && /Apple/i.test(navigator.vendor)) {
    type = "Safari";
    const match = userAgent.match(/Version\/(\d+(\.\d+)?)/);
    version = match ? match[1] : "";
  }

  return {
    type,
    version,
    isMobilePlatform,
    isChrome: type === "Chrome",
    isSafari: type === "Safari",
    isUnknown: type === "Unknown",
  };
};
